import axios from 'axios';

// Public site settings are needed by several components on every page (nav, footer, theme,
// chatbot, tracking, home). Share ONE request instead of each component fetching its own copy.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let pending = null;

// Resolves to an axios-style response ({ data }) so existing `.then(r => r.data)` code keeps working.
export const getSiteSettings = () => {
  if (!pending) {
    pending = axios.get(`${API}/settings`).catch((err) => {
      pending = null; // allow a retry after a failure
      throw err;
    });
  }
  return pending;
};

// Call after the admin saves settings so the next read is fresh.
export const invalidateSiteSettings = () => {
  pending = null;
};
